// L2 — intermediate level. Delegates L3 children to StageRailItemL3.
import { useState } from "react";
import { Lock } from "lucide-react";
import { RAIL_STATUS_META, effectiveStatus } from "./stageRailUtils";
import RailDependencyTooltip, { RailItemButton } from "./stageRailShared";
import StageRailItemL3 from "./StageRailItemL3";

export default function StageRailItemL2({
  stage, flatByCode, catalogue, activeCode, onPick, gateStatus,
  phaseVisibility, projectId, downloadableModules,
}) {
  const [open, setOpen] = useState(false);
  const [depsOpen, setDepsOpen] = useState(false);
  const state = flatByCode[stage.code] || { status: "not_started" };
  const effStatus = effectiveStatus(stage, state, flatByCode);
  const isLocked = effStatus === "locked";
  const meta = RAIL_STATUS_META[isLocked ? "not_started" : effStatus] || RAIL_STATUS_META.not_started;
  const Icon = isLocked ? Lock : meta.Icon;
  const subs = stage.sub_stages || [];
  const isActive = activeCode === stage.code;
  const hasSubs = subs.length > 0;
  const phaseCell = phaseVisibility?.stages?.[stage.code];
  const gate = gateStatus?.[stage.code] || null;

  return (
    <div data-testid={`rail-stage-${stage.code}`}
         style={{ position: "relative" }}>
      <RailItemButton
        stage={stage} level={2} isLocked={isLocked} isActive={isActive}
        meta={meta} Icon={Icon} hasSubs={hasSubs} open={open}
        pad={28} fontSize={12}
        phaseCell={phaseCell}
        gate={gate}
        onClick={() => {
          onPick(stage.code);
          if (hasSubs) setOpen(!open);
          if (isLocked) setDepsOpen(!depsOpen);
        }}
      />
      {isLocked && depsOpen && (
        <RailDependencyTooltip stageSpec={stage} flatByCode={flatByCode} catalogue={catalogue} />
      )}
      {hasSubs && open && (
        <div>
          {subs.map((ss) => (
            <StageRailItemL3 key={ss.code} stage={ss}
                flatByCode={flatByCode} catalogue={catalogue}
                activeCode={activeCode} onPick={onPick}
                gateStatus={gateStatus}
                phaseVisibility={phaseVisibility}
                projectId={projectId}
                downloadableModules={downloadableModules} />
          ))}
        </div>
      )}
    </div>
  );
}
